// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"a3f90b02","189":"52db4003","199":"2affc93e","203":"666e0261","267":"bc352d85","338":"3c234979","351":"4475001a","511":"da897515","714":"a519fb7b"}[chunkId] + ".chunk.css";
};